import { MASTER_RECORD_TYPE_NAME } from './parser';

export { MASTER_RECORD_TYPE_NAME };
export const FULL_NAME_SEPARATOR = '%&?';
export const RT_NAME_FUNNEL_ID_SEPARATOR = '?$%=';

export const createStepIdentifier = ({
  objectName,
  leadingField,
  stepFullName,
}: {
  objectName: string;
  leadingField: string;
  stepFullName: string;
}): string =>
  `${objectName}${FULL_NAME_SEPARATOR}${leadingField}${FULL_NAME_SEPARATOR}${stepFullName}`;

export const createRecordTypeIdentifier = ({
  recordTypeName,
  funnelId,
  objectName,
}: {
  recordTypeName: string;
  funnelId: string;
  objectName: string;
}): string =>
  `${
    recordTypeName ?? MASTER_RECORD_TYPE_NAME
  }${RT_NAME_FUNNEL_ID_SEPARATOR}${funnelId}.${objectName}`;

export const getDataFromRecordTypeIdentifier = (
  recordTypeIdentifier: string,
): {
  objectName: string;
  recordTypeName: string;
  funnelId: string | undefined;
  recordTypeNameAndFunnelId: string;
} => {
  const [recordTypeNameAndFunnelId, objectName] = recordTypeIdentifier.split('.');
  const [recordTypeName, funnelId] = (recordTypeNameAndFunnelId ?? '').split(
    RT_NAME_FUNNEL_ID_SEPARATOR,
  );
  return {
    objectName: objectName ?? '',
    recordTypeName: recordTypeName ?? '',
    funnelId: funnelId || undefined,
    recordTypeNameAndFunnelId: recordTypeNameAndFunnelId ?? '',
  };
};

export interface PillCountsByScope {
  steps: { [stepId: string]: number };
  funnels: { [funnelId: string]: number };
  objectType: { [objectName: string]: number };
  recordType: { [recordTypeKey: string]: number };
}

export interface PillsMap {
  // SF elements (from parser)
  sfdcAutomations: PillCountsByScope;
  validationRules: PillCountsByScope;
  apex: PillCountsByScope;
  funnelSfcAutomations: PillCountsByScope;
  funnelValidationRules: PillCountsByScope;
  funnelApex: PillCountsByScope;
  // Sweep elements (from deployed automations)
  sweepAutomations: PillCountsByScope;
  alerts: PillCountsByScope;
  assignments: PillCountsByScope;
  dedupe: PillCountsByScope;
  matching: PillCountsByScope;
  scheduledAssignments: PillCountsByScope;
}

export interface PillStage {
  stageId: string;
  stageName: string;
}

export interface PillFunnel {
  id: string;
  objectName: string;
  leadingFieldName: string;
  recordTypeId: string;
  stages: PillStage[];
}

export interface OrgPillFunnels {
  crmOrgId: string;
  funnels: PillFunnel[];
}

export type PillsMapByOrg = Record<string, PillsMap>;
